<template>
  <div id="manage-series">
    <transition name="fade" appear>
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch("getData");
    this.$store.dispatch("getSeries");
    this.$store.dispatch("getVideos");
  }
};
</script>

<style>
.fade-enter-active {
  transition: opacity 0.5s;
}

.fade-enter {
  opacity: 0;
}
</style>

